import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

import SidebarReducer from "../reducer/sideBar_reducer";
import EmissionReducer from "../reducer/EmissionReducer";
import ECommCustomersReducer from "../reducer/ECommCustomers/reducer";
import StewardReducer from "../reducer/StewardReducer";
import ECommRetailsReducer from "../reducer/ECommRetail/reducer";
import EGeneralReducer from "../reducer/General/reducer";
import {IKAMapReducer, CostCategoryReducer} from "../reducer/mappingFiles/reducer";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['sidebar']
}

const rootReducer = combineReducers({
    sidebar: SidebarReducer,
    emissions: EmissionReducer,
    steward: StewardReducer,
    eCommCustomers: ECommCustomersReducer,
    eCommRetail: ECommRetailsReducer,
    ikaMap: IKAMapReducer,
    costCategory: CostCategoryReducer,
    general: EGeneralReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistReducer(persistConfig, persistedReducer);